import { choiceKeyOf } from 'utils/library';

import { CONTROL_FIELD, ControlStatus } from './constants';

export const isProposed = (statusValue: unknown): boolean => choiceKeyOf(statusValue) === ControlStatus.Proposed;

export const CONTROL_RECORD_REQUIRED_KEYS = new Set<string>([
  CONTROL_FIELD.description,
  CONTROL_FIELD.category,
  CONTROL_FIELD.owner,
  CONTROL_FIELD.status,
  CONTROL_FIELD.dueDate,
]);
